// libs
import { styled } from '@nykaa/ui-components';

// components
import { ActionButton } from 'shared/components/Header/MobileHeader/styles/header';

// icons
// Icon is now passed from parent component for store-awareness

export const WishlistButton = styled(ActionButton)`
  position: relative;
  ${({ theme }) => theme.typography.bodyXSmall};
  display: flex;
  justify-items: center;
  align-items: center;
  width: 24px;

  svg {
    fill: ${({ theme }) => theme.colors.textPrimary};
  }
`;

